"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hungaryTranslations = void 0;
var _types = require("../../../types");
const hungaryTranslations = exports.hungaryTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Nagyon sajnáljuk!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Vissza',
  [_types.ErrorPageTranslationKey.text]: 'Az oldal jelenleg nem elérhető',
  [_types.ErrorPageTranslationKey.notFound]: 'Az Ön által keresett oldal törlésre került  vagy átmenetileg nem elérhető',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Az elérni kívánt oldal korlátozott, és nem teljesült minden feltétel.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Kérjük, vegye fel a kapcsolatot az Oriflame támogatási csapatával az alábbi e-mail címen:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'A kért URL-t elutasították!'
};
